import React from 'react';
import proContactMobile from '@core/ui/static/images/pro-contact-mobile.svg';

const ProContactMobileIcon = ({ className }) => (
  <div className={className}>
    <img
      src={proContactMobile}
      alt="pro-contact-mobile"
      width={224}
      height={185}
    />
  </div>
);

export default ProContactMobileIcon;
